import { Injectable, inject } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';

@Injectable({ providedIn: 'root' })
export class LanguageService {
  private readonly languageStorageKey = 'rp.lang';
  private readonly translocoService = inject(TranslocoService);

  initializeLanguage(): void {
    const savedLanguage = this.getSavedLanguage();
    if (savedLanguage) {
      this.translocoService.setActiveLang(savedLanguage);
      return;
    }

    const primaryBrowserLanguage = this.getPrimaryBrowserLanguage();
    const normalized = primaryBrowserLanguage.toLowerCase();
    if (normalized === 'fr' || normalized === 'fr-ca') {
      this.translocoService.setActiveLang('fr');
    }
  }

  getCurrentLanguage(): 'en' | 'fr' {
    return this.translocoService.getActiveLang().toLowerCase().startsWith('fr') ? 'fr' : 'en';
  }

  setLanguage(lang: string): 'en' | 'fr' {
    const selectedLang: 'en' | 'fr' = lang.toLowerCase().startsWith('fr') ? 'fr' : 'en';
    this.translocoService.setActiveLang(selectedLang);
    if (typeof localStorage !== 'undefined') {
      localStorage.setItem(this.languageStorageKey, selectedLang);
    }
    return selectedLang;
  }

  private getSavedLanguage(): 'en' | 'fr' | null {
    if (typeof localStorage === 'undefined') {
      return null;
    }

    const stored = localStorage.getItem(this.languageStorageKey);
    return stored === 'en' || stored === 'fr' ? stored : null;
  }

  private getPrimaryBrowserLanguage(): string {
    if (typeof navigator === 'undefined') {
      return '';
    }

    if (navigator.languages?.length) {
      return navigator.languages[0] ?? '';
    }

    return navigator.language ?? '';
  }
}
